module.exports = __webpack_public_path__ + "img/marathon.924a4439.jpg";